import React from 'react';
import { Link } from 'fw/components/formatter/Formatter';

class SearchQueueLinkByPersonAndQueue extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.value !== this.props.value;
	}

	_getLinkValue(isTotalsRow) {
		const row = this.props.dependentValues[0];
		const queueType = this.props.dependentValues[1]; // 'APP', 'CER', 'COM', 'STR', 'PD', or null for Total

		let url = '/admin/searchQueue?showAll=true&openOnly=true';

		if (queueType === 'PD') {
			// Pending Denials - filter by flag status only (no queue type, uses CertificationStatusCodes)
			url += '&flagStatusCode=PDN';
			if (!isTotalsRow) {
				url += `&assigneeId=${row.userId}`;
			}
		} else if (queueType !== null) {
			// Queue type specific - filter by queue type and In Progress status
			url += `&queueTypeCode=${queueType}&certificationStatusCode=ASG`;
			if (!isTotalsRow) {
				url += `&assigneeId=${row.userId}`;
			}
		} else {
			// Total column - no queue filter
			if (!isTotalsRow) {
				url += `&assigneeId=${row.userId}`;
			}
		}

		return {
			url: url,
			title: this.props.value !== undefined && this.props.value !== null ? this.props.value : 0
		};
	}

	render() {
		const row = this.props.dependentValues[0];
		const centerAlignStyle = { display: "block", textAlign: "center" };
		const value = this.props.value !== undefined && this.props.value !== null ? this.props.value : 0;
		const isTotalsRow = row.userId === 0 || row.userName === 'TOTALS';

		// Zero value - show plain number without link
		if (value === 0) {
			return (
				<span style={centerAlignStyle}>
					{value}
				</span>
			);
		}

		return <Link value={this._getLinkValue(isTotalsRow)} style={centerAlignStyle}></Link>
	}
}

export default SearchQueueLinkByPersonAndQueue;



// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/SearchQueueLinkByPersonAndQueue.js